module.exports = __webpack_public_path__ + "static/media/nithan_f_thumb.7c78d7aa.webp";